// TODO: create store is deprecated, see: https://redux.js.org/usage/migrating-to-modern-redux#store-setup-with-configurestore
import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { createBrowserHistory } from 'history';
import initialState from 'reducers/initialState';
import middleware from '../middleware';
import rootReducer from '../reducers';


export const history = createBrowserHistory();

export default function configureStore(preloadedState = initialState) {
  const store = createStore(
    rootReducer(history),
    preloadedState,
    composeWithDevTools(applyMiddleware(...middleware))
  );
  return store;
}
